import { Switch, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import React from 'react'
import { isEmail, ReactMultiEmail } from 'react-multi-email'
import styled from 'styled-components/macro'
import { venueSupplierDisplayTitle } from 'src/utils/growthEngineRestrictedSuppliers'

/**
 * First-try restrict sheet: Restricted toggle + who approves.
 * Accounting, hide-supplier, and catalogue stay on the Edit modal.
 */
const RestrictSupplierFirstTrySheet = ({
  venueSupplier,
  restricted,
  approvalEmails = [],
  onRestrictedChange,
  onApprovalEmailsChange,
}) => {
  const title = venueSupplierDisplayTitle(venueSupplier) || 'this supplier'

  return (
    <Wrap data-testid='restrict-first-try-sheet'>
      <SupplierName data-testid='restrict-first-try-supplier'>
        {title}
      </SupplierName>
      <ToggleRow>
        <ToggleLabel>
          <Tooltip title='When this is on, orders wait for a manager yes before they go to the supplier.'>
            <span>
              Restricted
              <InfoCircleOutlined style={{ marginLeft: 6, color: '#1890ff' }} />
            </span>
          </Tooltip>
        </ToggleLabel>
        <Switch
          checked={restricted === true}
          onChange={checked => onRestrictedChange?.(checked === true)}
          data-testid='restrict-first-try-toggle'
        />
      </ToggleRow>
      {restricted ? (
        <Row>
          <Label>Who approves</Label>
          <ReactMultiEmail
            placeholder='Enter email addresses'
            emails={approvalEmails}
            onChange={emails => onApprovalEmailsChange?.(emails)}
            validateEmail={email => isEmail(email)}
            getLabel={(email, index, removeEmail) => (
              <EmailTag data-tag key={index}>
                {email}
                <span data-tag-handle onClick={() => removeEmail(index)}>
                  ×
                </span>
              </EmailTag>
            )}
          />
        </Row>
      ) : (
        <Hint>Turn Restricted on to choose who approves orders.</Hint>
      )}
    </Wrap>
  )
}

export default RestrictSupplierFirstTrySheet

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const SupplierName = styled.p`
  margin: 0;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.bbqBlack};
`

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

const ToggleLabel = styled.span`
  font-weight: 500;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.span`
  font-weight: 500;
`

const Hint = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const EmailTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 2px;
  padding: 2px 8px;
  background: ${({ theme }) => theme.colours.mayoWhite};
  border: 1px solid ${({ theme }) => theme.colours.borderGrey};
  border-radius: 4px;
`
